import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/home/Home';
import { About } from './pages/about/About';
import { Parteners } from './pages/parteners/Parteners';
import { Contact } from './pages/contact/Contact';
// import { Solutions } from './pages/solutions/Solutions';
import { AskCharlee } from './pages/products/askcharlee/AskCharlee';
import { SeeCharlee } from './pages/products/seecharlee/SeeCharlee';
import { DocuCharlee } from './pages/products/docucharlee/DocuCharlee';
import { FindCharlee } from './pages/products/findcharlee/FindCharlee';
// import { Blogs } from './pages/blogs/Blogs';
// import { BlogContent } from './pages/blogs/BlogContent';
// import { EventContent } from './pages/blogs/EventContent';
// import { Usecase } from './pages/usecase/Usecase';
import ResearchPage from './pages/research/research';
import { VideoPages } from './pages/videos/videos';
import { RiteCharlee } from './pages/products/ritecharlee/RiteCharlee';
import { HubLayout } from './pages/new/layout/HubLayout';
import { HubSection } from './pages/new/layout/HubSection';
import { EventDetail } from './pages/new/event/EventDetail';
import { PodcastDetail } from './pages/new/podcast/PodcastDetail';
import { BlogDetail } from './pages/new/blog/BlogDetail';
import { UsecaseDetail } from './pages/new/usecase/UsecaseDetail';
import { NotFound } from './pages/notFound/NotFound';
import { KnowledgeCenter } from './pages/knowledge-center/KnowledgeCenter';
import { KnowledgeCenterSearch } from './pages/knowledge-center/KnowledgeCenterSearch';
import { KnowledgeCenterCategoryPage } from './pages/knowledge-center/KnowledgeCenterCategory';
import { KnowledgeCenterArticlePage } from './pages/knowledge-center/KnowledgeCenterArticle';
import { KnowledgeCenterGuidePage } from './pages/knowledge-center/KnowledgeCenterGuide';
import { KnowledgeCenterGuidesPage } from './pages/knowledge-center/KnowledgeCenterGuides';
import { KnowledgeCenterEbookPage } from './pages/knowledge-center/KnowledgeCenterEbook';
import { KnowledgeCenterEbookChapterPage } from './pages/knowledge-center/KnowledgeCenterEbookChapter';
import { KnowledgeCenterDictionaryPage } from './pages/knowledge-center/KnowledgeCenterDictionary';
import { KnowledgeCenterFaqs } from './pages/knowledge-center/KnowledgeCenterFaqs';
import { getRedirects } from './pages/knowledge-center/repository';

 export const Router = () => {
  return (
    <BrowserRouter >
      <Routes >
        <Route path="/articles/event/:eventName" element={<EventDetail />} />
        <Route path="/articles/podcast/:podcastName" element={<PodcastDetail />} />
        <Route path="/articles/blog/:blogName" element={<BlogDetail />} />
        <Route path="/articles/usecase/:usecaseName" element={<UsecaseDetail />} />
        <Route path="/articles" element={<HubLayout />}>
          <Route index element={<Navigate to="all" replace />} />
          <Route path=":section" element={<HubSection />} />
        </Route>
        <Route path="/knowledge-center/search" element={<KnowledgeCenterSearch />} />
        <Route path="/knowledge-center/resources/faqs" element={<KnowledgeCenterFaqs />} />
        <Route
          path="/knowledge-center/topics/:topicSlug"
          element={<KnowledgeCenterCategoryPage />}
        />
        <Route
          path="/knowledge-center/articles/:articleSlug"
          element={<KnowledgeCenterArticlePage />}
        />
        <Route
          path="/knowledge-center/dictionary"
          element={<KnowledgeCenterDictionaryPage />}
        />
        <Route
          path="/knowledge-center/guides"
          element={<KnowledgeCenterGuidesPage />}
        />
        <Route
          path="/knowledge-center/guides/:guideSlug"
          element={<KnowledgeCenterGuidePage />}
        />
        <Route
          path="/knowledge-center/ebooks/:ebookSlug/:chapterSlug"
          element={<KnowledgeCenterEbookChapterPage />}
        />
        <Route
          path="/knowledge-center/ebooks/:ebookSlug"
          element={<KnowledgeCenterEbookPage />}
        />
        {getRedirects().map((redirect) => (
          <Route
            key={redirect.from}
            path={redirect.from}
            element={<Navigate to={redirect.to} replace />}
          />
        ))}
        <Route path="/knowledge-center" element={<KnowledgeCenter />} />
        <Route path="/" element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/partners' element={<Parteners />} />
        <Route path='/connect' element={<Navigate to="/contact" replace />} />
        <Route path='/contact' element={<Contact />} />
        {/*
          Legacy routes disabled — replaced by /articles hub and detail pages.
          <Route path='/solutions1' element={<Solutions />}/>
          <Route path="/blogs/*" element={<Blogs />} />
          <Route path="/event/:eventname" element={<EventContent />} />
          <Route path="/blog/*" element={<BlogContent />} />
          <Route path='/usecase/*' element={<Usecase />} />
        */}
        <Route path='/product/askcharlee' element={<AskCharlee />} />
        <Route path='/product/seecharlee' element={<SeeCharlee />} />
        <Route path='/product/docucharlee' element={<DocuCharlee />} />
        <Route path='/product/findcharlee' element={<FindCharlee />} />
        <Route path='/product/ritecharlee' element={<RiteCharlee />} />
        <Route path='/solutions' element={<ResearchPage />} />
        <Route path='/videos-page' element={<Navigate to="/videos" replace />} />
        <Route path='/videos' element={<VideoPages />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
